import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Login from './Login';
import UserRegister from './UserRegister';
import EnterVerificationCode from './EnterVerificationCode';
// import EnterPassword from './EnterPassword';

const LoginRoute = () => {
  return (
    <Switch>
      <Route
        path='/login'
        exact
        render={(routeProps) => <Login {...routeProps} />}
      />
      <Route
        path='/login/register'
        exact
        render={(routeProps) => <UserRegister {...routeProps} />}
      />
      <Route
        path='/login/verification-code'
        exact
        render={(routeProps) => <EnterVerificationCode {...routeProps} />}
      />
    </Switch>
  );
};

export default LoginRoute;
